module.exports = __webpack_public_path__ + "static/media/qqe.b12cbbaa.mp3";